import React, { Fragment, useEffect } from 'react';
import useDashboardContext from 'contexts/dashboard.context';
import { Outlet, useNavigate, useParams } from 'react-router-dom';
import RightSidebar from 'components/right-sidebar';
import { ReactComponent as BrandDetailsIcon } from 'assets/icons/brand-details.svg';
import { ReactComponent as OpeningTimeIcon } from 'assets/icons/opening-time.svg';
import { ReactComponent as MetadataIcon } from 'assets/icons/metadata.svg';

const CareerContent = () => {
  const { job_id } = useParams();
  const navigate = useNavigate();

  const { setRightSection } = useDashboardContext();

  if (!job_id) {
    navigate(-1);
    return null;
  }

  const CareerDetailsNav = [
    {
      title: 'Job details',
      link: `career/${job_id}/details`,
      Icon: BrandDetailsIcon
    },

    {
      title: 'Job description',
      link: `career/${job_id}/description`,
      Icon: OpeningTimeIcon
    },
    {
      title: 'Application settings',
      link: `career/${job_id}/settings`,
      Icon: MetadataIcon
    }
  ];

  useEffect(() => {
    setRightSection(<RightSidebar list={CareerDetailsNav} />);

    return () => {
      setRightSection(null);
    };
  }, []);

  return (
    <Fragment>
      <Outlet />
    </Fragment>
  );
};

export default CareerContent;
